import { generateState } from '../builder'

export default {
  aiBook: {},
  ...generateState('getAiBook'),
  ...generateState('postAiBookGeneration'),
  ...generateState('postUpdateBook'),
}
